/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoxShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8.53 17.652 11 19.196v-5.642l-6-3.75V14H3V8a1 1 0 0 1 .47-.848l7.947-4.967a1.1 1.1 0 0 1 1.166 0l7.947 4.967A1 1 0 0 1 21 8v7.945a1.1 1.1 0 0 1-.517.933l-7.953 4.97a1 1 0 0 1-1.06 0l-4-2.5zM5.887 8 12 11.82 18.113 8 12 4.18zM13 13.554v5.642l6-3.75V9.804z" />
        <path d="M2.474 17.474 1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgBoxShortcut as BoxShortcut };
